export const DOMAIN = 'https://www.tableonline.fi',
  LOCALES = ['ee', 'en', 'fi'],
  ROOT =
    (typeof self === 'object' && self.self === self && self) ||
    (typeof global === 'object' && global.global === global && global) ||
    this,
  PRODUCTION = ROOT.location && ROOT.location.origin === DOMAIN ? true : false,
  LAMBDA = !PRODUCTION
    ? 'https://preprod-service.tableonline.fi'
    : 'https://service.tableonline.fi',
  API = 'https://s3-eu-west-1.amazonaws.com/tox-json',
  AVAILABILITYAPI =
    'https://mjiqkf3oq4.execute-api.eu-west-1.amazonaws.com/prod/bookable',
  FACEBOOKPIXEL = '172561719940552',
  GIFTCARD_AMOUNTS = [20, 50, 100, 150, 200, 250],
  GIFTCARD_DEFAULT_MAX_QUANTITY = 10,
  TAGMANAGER_ID = PRODUCTION ? 'GTM-WTBWJ3' : 'GTM-NMCV6RP',
  ANALYTICS_ID = PRODUCTION ? 'UA-19728430-6' : 'UA-67407950-3';



// WEBPACK FOOTER //
// ./globals.js